/**
 * @desc 更新流程下个审批人按钮
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(processKey: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/approvalFlow/${processKey}/updateNextApproval`, {
      method: "POST",

      ...options,
    }),
  );
}
